import camelCase from 'lodash/camelCase';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { projectSettingsServicedeskJourneyConfigurationEditRoute } from '@atlassian/jira-router-routes-project-settings-service-desk-journeys-routes/src/projectSettingsServicedeskJourneyConfigurationEditRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { journeyConfigEditPageEntryPoint } from './ui/journey-config-edit/index.tsx';

export const projectSettingsServicedeskJourneyConfigurationEditRouteEntry: Route = createEntry(
	projectSettingsServicedeskJourneyConfigurationEditRoute,
	() => ({
		group: 'project-settings-servicedesk',

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},

		meta: {
			reporting: {
				id: 'jsm.journey-builder.journey-config',
				packageName: camelCase('journey-config'),
				teamName: 'JSM Getting Started',
			},
		},

		layout: serviceProjectLayout,
		resources: [...getServiceDeskSettingsResources()],
		perfMetricKey: 'jsm-journey-configuration-edit',
		entryPoint: () => journeyConfigEditPageEntryPoint,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-service-desk-journeys-entries/src/projectSettingsServicedeskJourneyConfigurationEditRouteEntry.tsx',
				whichExportToUse: 'projectSettingsServicedeskJourneyConfigurationEditRouteEntry',
			},

			enabled: true,
		},
	}),
);
